export default __webpack_public_path__ + "static/media/home-background.6792c747.png";